var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseButtonHair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_9525",
    "data-name": "\\u9577\\u65B9\\u5F62 9525",
    width: 17,
    height: 17,
    transform: "translate(0 -0.214)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_16842",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 16842",
    transform: "translate(-1502 -5893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "settings",
    transform: "translate(1512 5902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_u30D1_u30B9_21238",
    "data-name": "\\\\\\\\u30D1\\\\\\\\u30B9 21238",
    d: "M0,0H25.8V25.8H0Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_u30D1_u30B9_21239",
    "data-name": "\\\\\\\\u30D1\\\\\\\\u30B9 21239",
    d: "M20.716,13.8a8.376,8.376,0,0,0,.075-1.054,8.377,8.377,0,0,0-.075-1.054l2.269-1.773a.542.542,0,0,0,.129-.688L20.963,5.513a.54.54,0,0,0-.656-.237L17.631,6.353A7.854,7.854,0,0,0,15.816,5.3l-.408-2.849A.522.522,0,0,0,14.879,2h-4.3a.522.522,0,0,0-.527.452L9.645,5.3A8.261,8.261,0,0,0,7.828,6.353L5.151,5.279a.522.522,0,0,0-.656.237L2.346,9.234a.53.53,0,0,0,.129.688L4.743,11.7a8.525,8.525,0,0,0-.075,1.054A8.525,8.525,0,0,0,4.743,13.8L2.475,15.578a.542.542,0,0,0-.129.688L4.5,19.985a.54.54,0,0,0,.656.237l2.677-1.075A7.853,7.853,0,0,0,9.644,20.2l.408,2.849a.522.522,0,0,0,.527.451h4.3a.522.522,0,0,0,.527-.452l.408-2.849a8.261,8.261,0,0,0,1.816-1.054l2.677,1.075a.522.522,0,0,0,.656-.237l2.15-3.719a.542.542,0,0,0-.127-.685ZM12.73,16.512a3.762,3.762,0,1,1,3.762-3.762A3.762,3.762,0,0,1,12.73,16.512Z",
    transform: "translate(0.17 0.149)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15102",
    "data-name": "\\u9577\\u65B9\\u5F62 15102",
    width: 45,
    height: 45,
    rx: 7,
    transform: "translate(1502 5893)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_16841",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 16841",
    transform: "translate(1516.076 5905.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15522",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15522",
    transform: "translate(-0.076 1.523)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21234",
    "data-name": "\\u30D1\\u30B9 21234",
    d: "M31.944,33.843a1.9,1.9,0,0,1-1.343-.555l-5.179-5.179-5.179,5.179A1.9,1.9,0,0,1,17.555,30.6l5.179-5.179-5.179-5.179a1.9,1.9,0,0,1,2.687-2.687l5.179,5.179L30.6,17.555a1.9,1.9,0,0,1,2.687,2.682l-5.179,5.179L33.288,30.6a1.9,1.9,0,0,1-1.343,3.242",
    transform: "translate(-17.029 -17)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButtonHair);
export default __webpack_public_path__ + "static/media/closeButtonHair.9e6b00d29f4cc57cde069a763049a885.svg";
export { ForwardRef as ReactComponent };